import { createContext } from 'react';

const IntlContext = createContext({ intl: { locale: 'en', translation: {} }, setIntl: () => {} });

export default IntlContext;
